const TZ = "Asia/Jerusalem";

const dateFmt = new Intl.DateTimeFormat("ru-RU", {
  timeZone: TZ,
  weekday: "short",
  day: "numeric",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
});

/** "пт, 15 мая, 19:30" — Jerusalem time, Russian locale. */
export function formatStartsAt(iso: string): string {
  const parts = dateFmt.formatToParts(new Date(iso));
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? "";
  return `${get("weekday")}, ${get("day")} ${get("month")}, ${get("hour")}:${get("minute")}`;
}
